module.exports = __webpack_public_path__ + "static/media/Teams-Inactive.e7b2cbd5.svg";